/**
 * Main tab screen components.
 */
import DailyMenuFlowScreen from '../../dailyMenu/DailyMenuFlowScreen';
import MenuFlowScreen from '../../menu/MenuFlowScreen';
import CalendarScreen from '../../calendar/CalendarScreen';
import DashboardScreen from '../../dashboard/DashboardScreen';
import AccountsScreen from '../../accounts/AccountsScreen';
import OrderScreen from '../../orders/OrderScreen';

export const MainTabAccountsScreen = AccountsScreen;
export const MainTabCalendarScreen = CalendarScreen;
export const MainTabDashboardScreen = DashboardScreen;
export const MainTabMenuFlowScreen = MenuFlowScreen;
export const ResolvedDailyMenuFlowScreen = DailyMenuFlowScreen;
export const ResolvedOrderScreen = OrderScreen;
